export default __webpack_public_path__ + "a8a89a2a66c32ebf0b53a30269b9ff3a.jpg";